import React from 'react';
import ReactDOM from 'react-dom/client'; // nuevo en React 18
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// Puedes seguir usando serviceWorker si lo necesitas
serviceWorker.unregister();